import { z } from 'zod'

/**
 * Tenant-level changes recorded in the tenant activity log. Stored as text in
 * `tenant_activity.type`; this list is the only set of values written.
 */
export const TENANT_ACTIVITY_TYPES = [
  'member.invited',
  'member.invite_revoked',
  'member.joined',
  'member.role_changed',
  'member.removed',
  'tenant.created',
  'tenant.updated',
  'tenant.suspended',
  'tenant.reactivated',
  'tenant.closed',
  'tenant.reopened',
  'tenant.purged',
  'staff.viewed',
  'api_key.created',
  'api_key.revoked',
  'webhook.url_changed',
  'webhook.secret_rotated',
  'webhook.previous_secret_retired',
  'embed_origins.changed',
  'allowlist.added',
  'allowlist.verified',
  'allowlist.lapsed',
  'allowlist.removed',
  'mcp.connected',
  'mcp.disconnected',
  'mcp.confirmation_declined',
  'mcp.access_changed',
  'mcp.setting_changed',
  'billing.credit_granted',
  'billing.exemption_changed',
  'billing.credit_purchased',
  'billing.refunded',
  'billing.settings_changed',
  'billing.price_notice',
  'billing.auto_reload_paused',
] as const

export const tenantActivityTypeSchema = z.enum(TENANT_ACTIVITY_TYPES)

export type TenantActivityType = z.infer<typeof tenantActivityTypeSchema>
